import styled from 'styled-components';

const ContenedorError = styled.div`
  max-width: 450px;
  margin: 0 auto;
  margin-top: 0px;
  margin-bottom: 0px;
  padding: 15px;
  .error-info img {
    filter: none;
  }
  h2 {
    font-size: 18px;
    color: #383838;
    font-weight: bold;
  }
  .error-info {
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .error-info img {
    margin: 20px auto;
  }
  .error-info h2 {
    font-size: 20px;
  }
  .error-info p {
    color: #252525;
    font-size: 14px;
    font-weight: 400;
    padding-bottom: 46px;
    max-width: 330px;
    line-height: 22px;
  }
  .error-info button {
    margin-bottom: 26px;
  }
`;

export default ContenedorError;
